import { useEffect, useState } from 'react';
import { useVideoContext } from '../../main';
export default function useParticipantConnected() {
    const { room } = useVideoContext();
    const [participant, setParticipant] = useState();
    useEffect(() => {
        room.on('participantConnected', setParticipant);
        const cb = () => {
            room.off('participantConnected', setParticipant);
        };
        return cb;
    });
    return participant;
}
//# sourceMappingURL=useParticipantConnected.js.map